<template>
  <div>
    <!-- <div v-show="refreshNevLeft"></div> -->
    <ClientOnly>
      <Row class="container">
        <Col
          span="4"
          class="nav-left"
        >
          <RouterLink to="/seller-center/home">
            <div class="logo">
              <img
                src="../assets/img/logo/nav-logo.png"
                alt="logo"
                class="logo-img"
              >
            </div>
          </RouterLink>
          <div
            :style="styleObj"
            class="menu-dev"
          >
            <Menu
              ref="menu"
              :accordion="true"
              width="100%"
              :active-name="activeMenuId"
              :open-names="openedSubmenuIds"
              @on-select="handleSelectMenu"
            >
              <MenuItem
                :name="1"
                to="/seller-center/home"
                style="margin-left: 5px"
              >
                <i class="iconfont icon-home" />
                {{ $t('sc.sellerCenter.home') }}
              </MenuItem>
              <Submenu
                v-for="item in menu"
                :key="item.id"
                :name="item.id"
              >
                <template #title>
                  <Badge
                    v-if="item.id === 4"
                    :count="messageNotReadTotal"
                  >
                    <span style="padding-right: 10px;">
                      <i :class="`iconfont ${menuIcon(item)}`" />
                      {{ $t(item.name) }}
                    </span>
                  </Badge>

                  <Badge
                    v-else-if="item.id === 9 && !whatsappNumber && Number($cookies.get('sellerRegionId')) !== 2"
                    dot
                  >
                    <span style="padding-right: 10px;">
                      <i :class="`iconfont ${menuIcon(item)}`" />
                      {{ $t(item.name) }}
                    </span>
                  </Badge>

                  <span v-else>
                    <i :class="`iconfont ${menuIcon(item)}`" />
                    {{ $t(item.name) }}
                  </span>
                </template>
                <MenuItem
                  v-for="subItem in item.pages"
                  :key="subItem.id"
                  :name="subItem.id"
                  :to="`/seller-center/${subItem.url}`"
                >
                  <Badge
                    v-if="subItem.id === 47"
                    :count="messageNotReadTotal"
                  >
                    <span style="padding-right: 10px;">
                      {{ subItem.name }}
                    </span>
                  </Badge>
                  <Badge
                    v-else-if="subItem.id === 13 && !whatsappNumber && Number($cookies.get('sellerRegionId')) !== 2"
                    dot
                  >
                    <span style="padding-right: 10px;">
                      {{ subItem.name }}
                    </span>
                  </Badge>
                  <Badge v-else-if="subItem.url === 'activityintegrate' && invitationUnread" dot>
                    <span style="padding-right: 10px;">{{ subItem.name }}</span>
                  </Badge>
                  <span v-else>
                    {{ subItem.name }}
                  </span>
                </MenuItem>
              </Submenu>
            </Menu>
          </div>
        </Col>
        <Col
          span="20"
          class="main"
        >
          <div class="header">
            <div class="header-top">
              <el-popover placement="bottom" width="190" trigger="click">
                <div class="seller-app-download">
                  <p class="download-text">
                    {{ $t('sc.sellerCenter.downloadAppleApp') }}
                  </p>
                  <div class="download-img">
                    <img
                      src="https://image.kilimall.com/seller-pc/new_seller_app_qr.png"
                      alt="apple"
                      class="google-play-qr"
                    >
                  </div>
                  <div class="download-img">
                    <img
                      src="https://image.kilimall.com/kenya/PcImages/static/google-play.png"
                      alt="apple"
                      class="google-play-img"
                      @click="downLoadAppClick(2)"
                    >
                  </div>
                  <el-button
                    type="primary"
                    size="large"
                    @click="downLoadAppClick(1)"
                  >
                    {{ $t('sc.sellerCenter.directDownload') }}
                  </el-button>
                </div>
                <span slot="reference" class="help-center">
                  {{ $t('sc.sellerCenter.sellerApp') }}
                </span>
              </el-popover>
              <div class="space" />
              <div class="help-center" @click="goFeedbackAndComplaint">
                {{ $t('sc.sellerCenter.feedbackAndComplaint') }}
                <el-icon size="16" name="edit-outline" />
              </div>
              <div class="space" />
              <div class="help-center" @click="goHelpCenter">
                {{ $t('sc.sellerCenter.sellerUniversity') }}
                <Icon type="md-open" color="#999" :size="16" />
              </div>
              <div class="space" />
              <Select
                v-model="storeId"
                style="width: 150px"
                size="small"
                @on-change="switchStore"
              >
                <Option
                  v-for="item in storeList"
                  :key="item.storeName"
                  :value="item.storeId"
                >
                  {{ `(${item.storeId})${item.storeName}` }}
                </Option>
              </Select>
              <!-- iview国际化会导致 js 唤起 Modal 报错，待处理，按钮隐藏
               （已处理2021年3月10日10:51:29） -->
              <div class="space" />
              <div class="set-language">
                <LocalSet />
              </div>
              <div class="space" />
              <div class="header-item">
                <Dropdown @on-click="menuChange">
                  <span>
                    <Avatar
                      style="background-color: white"
                      :src="avatar"
                      :onerror="avatarError"
                    />
                  </span>
                  <span class="user-name">
                    {{ userName }}
                  </span>
                  <template #list>
                    <DropdownMenu style="text-align: center">
                      <DropdownItem
                        name="Login"
                        divided
                      >
                        {{ $t('sc.sellerCenter.loginOut') }}
                      </DropdownItem>
                    </DropdownMenu>
                  </template>
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="content">
            <RouterTab
              :i18n="i18n"
              :page-transition="{ duration: 0 }"
              :tabs="tabs"
            />
          </div>
          <div
            class="footer"
            style="font-size: 10px"
          >
            {{ $t('sc.sellerCenter.footer') }} {{ new Date().getFullYear() }}
          </div>
          <div class="cn_chat_div">
            <div class="cn_chat_qrd_div">
              <img
                src="https://image.kilimall.com/kenya/qrcode/chat_qr_icon.png"
                alt="wx_chat_qrc"
              >
              扫码联系客服
            </div>
            <img
              src="https://image.kilimall.com/kenya/seller/chat_icon.png"
              alt="chat_icon"
            >
          </div>
          <div
            class="en_chat_div"
            @click="chatClick"
          >
            <img
              src="https://image.kilimall.com/kenya/seller/chat_icon.png"
              alt="chat_icon"
            >
          </div>
        </Col>
      </Row>
    </ClientOnly>
    <DepositPromoDialog
      :visible.sync="depositPromoVisible"
      :detail-data="depositPromoDetail"
      @completed="onDepositPromoCompleted"
    />
  </div>
</template>

<script>
import BusObject from '../utils/eventBus'
// import loading from '_c/loading'
import i18nMixins from './i18n-mixin'
import promotionInvitationMixin from './promotion-invitation-mixin'
// import messageMixin from './message-mixin'
import LocalSet from '../components/global/localDropdown.vue'
import DepositPromoDialog from '_pc/seller-center/deposit-promo/DepositPromoDialog'
import { storeId } from '_h/account'
import { mapState } from 'vuex'
import { getMenuAllListData } from '_h/public'
import ApiConfig from '@/server-config/domain.config'
import { mapGetters } from 'vuex/dist/vuex.common.js'
import { fetchDepositPromoIfNeeded } from '@/utils/deposit-promo-check'

const AFFILIATE_PAGE_URLS = ['cps-dashboard', 'cps-product-config', 'cps-order']
const AFFILIATE_STORE_TYPES = [1, 4]

export default {
  components: {
    LocalSet,
    DepositPromoDialog
  },
  mixins: [i18nMixins, promotionInvitationMixin],
  data() {
    // const _t34 = this.$t('depositPaymentRecord.pageTitle')
    // const _t35 = this.$t('marginTurnover.pageText')
    // const _t37 = this.$t('marginAndDisclaimerInfo.pageTitle')
    return {
      tabs: [
        {
          to: '/seller-center/home',
          title: 'i18n:sc.home.home',
          closable: false
        }
      ],
      historyNevLeft: false,
      menuId2Icon: {
        // 1: "icon-xitongguanli", // System
        2: 'icon-goods', // Products
        3: 'icon-dingdanguanli', // Order
        4: 'icon-shouhoufuwu-chapingfangyu', // 服务
        5: 'icon-cangku', // 备货
        6: 'icon-miaosha', // 促销
        7: 'icon-baobiao1', // 洞察
        8: 'icon-chengbenjisuangongshi', // 财务
        9: 'icon-dianpu-copy', // 店铺设置
        10: 'icon-icon04', // 商户设置
        // 10: "icon-pingjia-copy", // Product Reviews
        // 11: "icon-cangku", // Warehouse&Delivery
        12: 'icon-wuliuguanliicon', // 物流和交付管理
        13: 'icon-shouhou' // as3
        // 14: "icon-choujiang", // Lucky Draw
        // 15: "icon-jingxuan", // Selection
        // 17: "icon-cuxiaohuodong", // 活动管理
        // 11: 'icon-tuangouicon', // 拼团
        // 12: 'icon-wuliuguanliicon',
        // 13: 'icon-baobiao1'
      },
      styleObj: {
        height: '100%',
        'overflow-x': 'auto',
        'padding-top': '30px'
      },
      avatar: require('../assets/img/header/avatar.jpg'),
      avatarError: `this.src="${require('../assets/img/header/avatar.jpg')}"`,
      userName: '',
      menu: [],
      storeList: [],
      storeId: '',
      depositPromoVisible: false,
      depositPromoDetail: null,
      oldSellerUrl: '',
      feeMenuConfig: null
    }
  },
  // 添加 fetchOnServer: true 确保在服务端执行
  fetchOnServer: true,
  async fetch() {
    // 在服务端获取 feeMenu 配置
    try {
      const response = await this.$axios.get(
        `${
          ApiConfig.HW_OBS
        }/seller/feeMenu/feeMenu.json?s=${new Date().getTime()}`
      )
      this.feeMenuConfig = response.data
    } catch (error) {
      this.feeMenuConfig = {
        feeSwitch: {
          enabled: false,
          specificShops: []
        },
        billSwitch: {
          enabled: false,
          specificShops: []
        }
      }
      console.error('获取feeMenu.json配置失败:', error)
    }
  },
  computed: {
    ...mapState(['messageNotReadTotal']),
    ...mapGetters(['whatsappNumber']),
    /**
     * 根据当前路由匹配侧边栏菜单 id，用于高亮。
     * 程序打开页签时 $route.meta.id 往往为空，改为用 url 对齐菜单。
     */
    activeMenuId() {
      const matched = this.getMatchedMenuPage()
      if (matched) return matched.page.id
      if (this.$route.path.includes('/seller-center/home')) return 1
      return this.$route.meta.id
    },
    openedSubmenuIds() {
      const matched = this.getMatchedMenuPage()
      return matched ? [matched.group.id] : []
    }
  },
  watch: {
    '$i18n.locale': {
      handler(newVal) {
        this.setChatPlat(newVal)
        this.getMenuAllList()
      }
    },
    '$route.path'() {
      this.syncSideMenu()
    },
    menu() {
      this.syncSideMenu()
    }
  },
  async mounted() {
    this.initI18n()
    this.$initSocket && this.$initSocket()
    this.queryStoreList()
    this.storeId = Number(this.$cookies.get('store-id'))

    // 如果 feeMenuConfig 为空，在客户端重新获取
    if (!this.feeMenuConfig) {
      await this.fetchFeeMenuConfig()
    }

    if (!this.$store.state.storeInfo?.storeId) {
      await this.$store.dispatch('initStoreInfo')
    }

    this.checkDepositPromo()

    this.$Message.config({
      top: 100,
      duration: 3
    })
    this.$Notice.config({
      top: 100,
      duration: 3
    })
    this.styleObj.height = `${window.innerHeight - 160}px`
    const account = this.$cookies.get('user-account')
    this.userName = account || this.$t('sc.sellerCenter.userName')
    const avatar = this.$cookies.get('store-logo')
    this.avatar =
      avatar === 'null' || avatar === null
        ? require('../assets/img/header/avatar.jpg')
        : avatar

    const { $Bus, BusEvent } = BusObject
    $Bus.$on(BusEvent.FLAG_NAVLEFT, async () => {
      await this.permissionChange()
    })
    await this.initFreshChat()
    this.$nextTick(() => {
      this.setChatPlat(this.$i18n.locale)
      !this.menu.length && this.getMenuAllList()
    })
    window.fcWidget.on('widget:closed', () => {
      this.setBodyClassName('')
    })
  },
  beforeUnmount() {
    const { $Bus, BusEvent } = BusObject
    $Bus.$off(BusEvent.FLAG_NAVLEFT)
  },
  methods: {
    // 校验店铺保证金/推广金缴纳状态（进入商家中心或切换店铺后触发）
    async checkDepositPromo() {
      try {
        const detail = await fetchDepositPromoIfNeeded(this.$axios)
        if (detail) {
          this.depositPromoDetail = detail
          this.depositPromoVisible = true
        }
      } catch (e) {
        console.error('checkDepositPromo error:', e)
      }
    },
    onDepositPromoCompleted() {
      this.depositPromoVisible = false
    },
    // 添加 fetchFeeMenuConfig 方法用于客户端获取数据
    async fetchFeeMenuConfig() {
      try {
        const response = await this.$axios.get(
          `${
            ApiConfig.HW_OBS
          }/seller/feeMenu/feeMenu.json?s=${new Date().getTime()}`
        )
        this.feeMenuConfig = response.data
      } catch (error) {
        this.feeMenuConfig = {
          feeSwitch: {
            enabled: false,
            specificShops: []
          },
          billSwitch: {
            enabled: false,
            specificShops: []
          }
        }
        console.error('客户端获取feeMenu.json配置失败:', error)
      }
    },
    menuIcon(item) {
      const isAffiliateMenu = (item.pages || []).some(page => AFFILIATE_PAGE_URLS.includes(page.url))
      return isAffiliateMenu ? 'icon-user' : this.menuId2Icon[item.id]
    },
    async setMenuData(arr) {
      let canUseProductMarketExpansion = false
      try {
        const response = await this.$axios.get('/store/account/market-regions')
        const markets = response.data.data.localizedSubsidiaries || []
        canUseProductMarketExpansion = markets.some(
          item => item.isBaseStation
        )
      } catch (error) {
        console.error(error)
      }

      const permissions = JSON.parse(this.$storage.get('permissions') || '{}')
      const pagesUsable = permissions.pagesUsable || []
      const sellerRegionId = this.$cookies.get('sellerRegionId')
      const businessType = this.$store.state.storeInfo?.businessType
      const canAccessAffiliateMenu = Number(sellerRegionId) === 2
        || AFFILIATE_STORE_TYPES.includes(Number(businessType))
      const newArr = []
      // 获取当前店铺ID
      const currentStoreId = this.$cookies.get('store-id')
      // 申诉相关菜单（4 个）暂时隐藏
      const hiddenMenuIds = [
        74, // 物流费用申诉管理
        75, // 支付费用申诉管理
        76, // 商城费用申诉管理
        77 // 新费用申诉
      ]
      // 试运行阶段菜单：需要在名称后追加 (Trial)，非试运行菜单优先展示，试运行菜单按下方顺序追加在后
      const trialMenuOrder = [
        72, // 账单
        71, // 欠费补缴单
        69, // 订单取消
        67, // 售后扣款
        70, // 商品违规下架
        79, // 维修费
        68, // 物流费用和扣款
        66, // 商家FBK库存申诉
        73 // 丢损件赔付
      ]
      const trialMenuSet = new Set(trialMenuOrder)
      // 先处理非费用账单菜单
      const processFeeMenuItems = (feeMenuConfig = null) => {
        arr.forEach(item => {
          if (!item?.pages?.length) {
            return
          }
          const { pages, ...data } = item
          const pagArr = {
            ...data,
            pages: []
          }
          const hasConfiguredCpsDashboard = pages.some(page => page.url === 'cps-dashboard')
          const hasConfiguredCpsOrder = pages.some(page => page.url === 'cps-order')
          // 费用、账单相关菜单ID
          const billMenu = [72]
          const feeMenu = [66, 67, 68, 69, 70, 71, 73, 74, 75, 76, 77, 79]
          pages.forEach(pagItem => {
            // 特殊处理，非中国卖家不能看到中国区菜单；Affiliate 对指定店铺类型开放
            const isChinaOnlyPage = [48, 49, 8, 63].includes(pagItem.id)
            const isAffiliatePage = AFFILIATE_PAGE_URLS.includes(pagItem.url)
            if (
              (isChinaOnlyPage && Number(sellerRegionId) !== 2)
              || (isAffiliatePage && !canAccessAffiliateMenu)
            ) {
              return
            }
            if (hiddenMenuIds.includes(pagItem.id)) {
              return
            }
            if (pagItem.id === 8 && !canUseProductMarketExpansion) {
              return
            }
            // 判断是否为费用或账单菜单
            if (
              (billMenu.includes(pagItem.id) ||
                feeMenu.includes(pagItem.id)) &&
              feeMenuConfig
            ) {
              // 获取菜单类型和名称
              const menuType = billMenu.includes(pagItem.id)
                ? 'billSwitch'
                : 'feeSwitch'
              // 检查菜单是否启用
              const menuConfig = feeMenuConfig[menuType]
              if (menuConfig) {
                if (menuConfig.enabled) {
                  if (pagesUsable.includes(pagItem.id)) {
                    pagArr.pages.push(pagItem)
                  }
                } else {
                  // 检查是否有特定店铺配置
                  const specificShops = menuConfig.specificShops || []
                  // 如果没有特定店铺配置或当前店铺在特定店铺列表中，则显示菜单
                  if (
                    specificShops.length > 0 &&
                    specificShops.includes(currentStoreId)
                  ) {
                    if (pagesUsable.includes(pagItem.id)) {
                      pagArr.pages.push(pagItem)
                    }
                  }
                }
              }
            } else {
              // 非费用账单菜单或配置获取失败时，正常处理
              if (pagesUsable.includes(pagItem.id)) {
                pagArr.pages.push(pagItem.id === 89 || pagItem.url === 'cps-product-config'
                  ? { ...pagItem, name: this.$t('sc.cpsProductConfig.pageTitle') }
                  : pagItem)
              }
            }
          })
          let cpsProductIndex = pagArr.pages.findIndex(page => page.id === 89)
          const cpsDashboardIndex = pagArr.pages.findIndex(page => page.url === 'cps-dashboard')
          const cpsOrderIndex = pagArr.pages.findIndex(page => page.url === 'cps-order')
          if (canAccessAffiliateMenu && cpsProductIndex !== -1) {
            if (cpsDashboardIndex !== -1) {
              const [cpsDashboardPage] = pagArr.pages.splice(cpsDashboardIndex, 1)
              cpsProductIndex = pagArr.pages.findIndex(page => page.id === 89)
              pagArr.pages.splice(cpsProductIndex, 0, cpsDashboardPage)
            } else if (!hasConfiguredCpsDashboard) {
              pagArr.pages.splice(cpsProductIndex, 0, {
                id: 'cps-dashboard',
                name: this.$t('sc.cpsDashboard.menuTitle'),
                url: 'cps-dashboard'
              })
            }
            cpsProductIndex = pagArr.pages.findIndex(page => page.id === 89)
            if (cpsOrderIndex !== -1) {
              const currentCpsOrderIndex = pagArr.pages.findIndex(page => page.url === 'cps-order')
              const [cpsOrderPage] = pagArr.pages.splice(currentCpsOrderIndex, 1)
              cpsProductIndex = pagArr.pages.findIndex(page => page.id === 89)
              pagArr.pages.splice(cpsProductIndex + 1, 0, cpsOrderPage)
            } else if (!hasConfiguredCpsOrder) {
              pagArr.pages.splice(cpsProductIndex + 1, 0, {
                id: 'cps-order',
                name: this.$t('sc.cpsOrder.menuTitle'),
                url: 'cps-order'
              })
            }
          }
          if (pagArr.pages.length === 0) {
            return
          }
          // 命中试运行白名单：名称追加 (Trial)；非试运行菜单保持在前，试运行菜单按预定义顺序排在后
          const hasTrial = pagArr.pages.some(p => trialMenuSet.has(p.id))
          if (hasTrial) {
            const nonTrialPages = []
            const trialPages = []
            pagArr.pages.forEach(p => {
              if (trialMenuSet.has(p.id)) {
                const renamed = p.name && !p.name.includes('(Trial)')
                  ? { ...p, name: `${p.name} (Trial)` }
                  : p
                trialPages.push(renamed)
              } else {
                nonTrialPages.push(p)
              }
            })
            trialPages.sort((a, b) => trialMenuOrder.indexOf(a.id) - trialMenuOrder.indexOf(b.id))
            pagArr.pages = [...nonTrialPages, ...trialPages]
          }
          newArr.push(pagArr)
        })
        this.menu = newArr
      }
      // 使用服务端获取的 feeMenu 配置
      processFeeMenuItems(this.feeMenuConfig)
    },
    async getMenuAllList() {
      try {
        const res = await getMenuAllListData(
          this.$axios,
          { lang: this.$store.state.locale }
        )
        this.$store.commit('setMenuAllData', res)
        await this.setMenuData(res)
      } catch (error) {
        console.error(error)
        this.$handleError(this, error)
      }
    },
    i18n(key, params) {
      // $t 为实际项目中的全局国际化方法
      return this.$t(key, params)
    },
    menuChange(routerName) {
      if (routerName === 'Login') {
        this.$cookies.remove('user-account')
        this.$cookies.remove('user-token')
        this.$cookies.remove('user-id')
        this.$cookies.remove('region-id')
        this.$cookies.remove('seller-id')
        this.$cookies.remove('seller-type')
        this.$cookies.remove('store-id')
        this.$cookies.remove('store-name')
        this.$cookies.remove('store-logo')
        this.$cookies.remove('account-type')
        this.$cookies.remove('sellerRegionId')
        this.$storage.remove('regionList')
      }
      window.location.href = '/login'
      this.$store.commit('logOut')
      this.$ClearAllCookieFn()
      this.$router.replace('/') // this.$i18n.path("/"))

      this.$discountSocket && this.$discountSocket()
    },
    backTop() {
      document
        .querySelector('.router-tab__container')
        .scrollTo({ top: 0, behavior: 'smooth' })
    },
    permissionChange() {
      this.$axios
        .get('/store/account/permissions')
        .then(response => {
          const obj = response.data.data.permissions
          this.$storage.set('permissions', JSON.stringify(obj))
          // let pagesUsable = [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32]
          this.getMenuAllList()
        })
        .catch(error => {
          console.error(error)
          const err = error.response
          if (err.status > 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
          }
        })
    },
    // 获取店铺列表
    queryStoreList() {
      this.$axios
        .get('/stores')
        .then((response) => {
          const storeData = response.data.data.stores
          const isManage = this.$cookies.get('account-type') === 1
          if (isManage) {
            this.storeList = storeData
          } else {
            const storeId = Number(this.$cookies.get('store-id'))
            this.storeList = storeData.filter(item => item.storeId === storeId)
          }
        })
        .catch((error) => {
          console.error(error)
          const err = error.response
          if (err.status >= 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
          }
        })
    },
    downLoadAppClick(type) {
      // type 1直接下载 2 打开google play
      if (type === 1) {
        this.handleDownloadClick()
      } else {
        window.open('https://play.google.com/store/apps/details?id=com.kilimall.kseller')
      }
    },
    handleDownloadClick() {
      const ael = document.createElement('a')
      ael.href = 'https://app.kilimall.ke/app/sellerApp.apk'
      ael.download = 'download'
      document.body.appendChild(ael)
      ael.click()
      document.body.removeChild(ael)
      this.$Message.success(this.$t('sc.sellerCenter.downloadAppTip'))
    },
    goFeedbackAndComplaint() {
      const pathUrl =
        this.$i18n.locale === 'en'
          ? `https://qingflow.com/dashboard/0879dc38/view`
          : `https://qingflow.com/dashboard/ebb45588/view`

      window.open(pathUrl)
    },
    goHelpCenter() {
      const pathUrl =
        this.$i18n.locale === 'en'
          ? `${ApiConfig.WAP_URL}/help-center/homepage-eng?c_id=10&s_id=1006&bs_type=2`
          : `${ApiConfig.WAP_URL}/help-center/homepage-cn?c_id=9&s_id=1003&bs_type=2`

      window.open(pathUrl)
    },
    getArea(storeId) {
      this.$axios
        .get('/national-stations', {
          params: {
            stationType: 3,
            storeId
          }
        })
        .then((response) => {
          const countrylist = JSON.stringify(response.data.data)
          this.$SetCookieFn('countryList', JSON.stringify(countrylist))
        })
        .catch((error) => {
          console.error(error)
          const err = error.response
          if (err.status > 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
          }
        })
    },
    // 确定切换
    switchStore(id) {
      const objStore = this.storeList.find(item => item.storeId === id)
      if (!objStore.storeId) {
        this.$Message.warning(this.$t('sc.home.selectStore'))
        return
      }
      this.$RemoveCookie('store-id')
      this.$RemoveCookie('store-name')
      this.$RemoveCookie('store-logo')
      this.$axios
        .request(storeId(id))
        .then((res) => {
          if (res.data.code === 0) {
            this.$RemoveCookie('user-token')
            this.$SetCookieFn('user-token', res.data.data.token)
            // this.$SetCookieFn('user-refresh-token', res.data.data.refreshToken)
            // this.$SetCookieFn('user-token-timeout', res.data.data.accessTokenTimeout)
            this.$SetCookieFn('store-id', objStore.storeId)
            this.$SetCookieFn('store-name', objStore.storeName)
            this.$SetCookieFn('store-logo', objStore.storeLogo)
            this.$SetCookieFn('storeRegion-id', objStore.regionId)
            this.getArea(objStore.storeId)
            this.$Message.success(this.$t('sc.home.switchSuccess'))
            setTimeout(() => {
              window.location.reload()
            }, 100)
          }
        })
        .catch((error) => {
          console.error(error)
          const err = error.response
          if (err.status >= 500) {
            this.$Message.error(err.status + err.statusText)
          }
          if (err) {
            if (err.data.msg) {
              this.$Message.error(err.data.msg)
            }
          }
        })
    },
    async initFreshChat() {
      try {
        window.fcWidget.init({
          token: '99734cf7-c45b-46ed-9982-c0038b4f7d3b',
          host: 'https://wchat.freshchat.com'
        })
      // eslint-disable-next-line southx/add-console-error-in-catch
      } catch (err) {}
    },
    setChatPlat(newVal) {
      const chatObj = document.querySelector('.cn_chat_div')
      const chatObjEn = document.querySelector('.en_chat_div')
      if (!chatObj) {
        return
      }
      if (newVal === 'en') {
        chatObjEn.style.display = 'block'
        chatObj.style.display = 'none'
      } else {
        chatObj.style.display = 'block'
        chatObjEn.style.display = 'none'
      }
    },
    chatClick() {
      window.fcWidget.open()
      this.setBodyClassName('lan_en_body')
    },
    setBodyClassName(name) {
      const body = document.querySelector('body')
      body.className = name
    },
    handleSelectMenu(name) {
      if (name === 3) {
        this.$isRemainSettlement(this)
      }
    },
    /**
     * 用当前 path 匹配侧边栏菜单项（含新旧地址页别名）。
     *
     * @returns {{ group: Object, page: Object } | null}
     */
    getMatchedMenuPage() {
      const path = this.$route.path.replace(/\/$/, '')
      const aliases = {
        '/seller-center/address/newAfteShipping': ['address/newAfteShipping', 'address/shipping'],
        '/seller-center/address/newAfteReturn': ['address/newAfteReturn', 'address/return']
      }
      const extraUrls = aliases[path] || []
      for (const group of this.menu || []) {
        const page = (group.pages || []).find(item => {
          const menuPath = `/seller-center/${item.url}`
          return path === menuPath ||
            path.startsWith(`${menuPath}/`) ||
            extraUrls.includes(item.url)
        })
        if (page) {
          return { group, page }
        }
      }
      return null
    },
    syncSideMenu() {
      this.$nextTick(() => {
        if (!this.$refs.menu) return
        this.$refs.menu.updateActiveName && this.$refs.menu.updateActiveName()
        this.$refs.menu.updateOpened && this.$refs.menu.updateOpened()
      })
    }
  }
}
</script>
<style>
body #fc_frame.fc-widget-normal {
  display: none;
  position: absolute;
}
body.lan_en_body > #fc_frame.fc-widget-normal {
  display: block;
  position: absolute;
}
</style>
<style lang="scss" scoped>
/deep/ .container {
  width: 100% !important;
  // height: 100%;
  .nav-left {
    width: 15%;
    min-width: 180px;
    height: calc(100vh);
    background-color: #fff;
    border-right: 1px solid #e0e0e0;
  }
  .main {
    position: relative;
    height: 100vh;
    background-color: #f7f7f7;
    .cn_chat_div,
    .en_chat_div {
      width: 30px;
      height: 50px;
      position: fixed;
      top: 200px;
      right: 0px;
      text-align: center;
      cursor: pointer;
      background-color: #e8f1ff;
      border-radius: 5px 0 0 5px;
      padding-top: 12px;
      display: none;
      z-index: 9;
      img {
        width: 24px;
      }
    }
    .cn_chat_div {
      .cn_chat_qrd_div {
        position: absolute;
        right: 35px;
        top: 0px;
        padding: 5px;
        background-color: white;
        color: black;
        font-size: 14px;
        font-weight: bold;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: none;
        img {
          width: 160px;
        }
      }
      &:hover {
        .cn_chat_qrd_div {
          display: block;
        }
      }
    }
  }

  .content {
    position: relative;
    padding: 10px;
    height: calc(100vh - 60px - 20px);

    .router-tab {
      width: 100%;
      height: 100%;
      .router-tab__item.is-active,
      .router-tab__item:hover {
        color: #dd3131;
      }
      .router-tab__item-title {
        max-width: 100%;
      }
    }
    // .router-tab__container {
    // }
  }
}
.logo {
  text-align: center;
  height: 130px;
  padding: 55px 0;
  .logo-img {
    height: 55px;
  }

  .logo-title {
    color: #f4a422;
    font-size: 18px;
    letter-spacing: 1px;
    margin: auto 0;
  }
}

.header {
  background-color: #ffffff;
  text-align: right;
  .header-top {
    display: flex;
    justify-content: end;
    align-items: center;
    height: 60px;
    padding: 0 15px;
    font-size: 14px;
    .to-old-seller-center {
      margin-right: 15px;
      cursor: pointer;
      color: #00b4ff;
      &:hover {
        text-decoration: underline;
      }
    }
    .help-center {
      cursor: pointer;
    }
    .set-language {
      display: inline-block;
      font-size: 16px;
      cursor: pointer;
    }
    .space {
      display: inline-block;
      border-right: 1px solid #999;
      height: 16px;
      margin: 0 15px;
    }
    .header-item {
      display: inline-block;
      padding-left: 5px;
      .user-name {
        font-size: 14px;
        margin: 0 20px 0 10px;
      }
    }
  }
}
.disabled-menu {
  color: #999;
}
.footer {
  height: 20px;
  text-align: center;
  color: #999;
}
.menu::-webkit-scrollbar {
  display: none !important;
}
.menu-dev::-webkit-scrollbar {
  display: none;
}
/deep/ .router-tab__nav {
  background: white;
}
/deep/ .ivu-back-top {
  display: block;
}
/deep/ .router-tab__scroll {
  z-index: -9999;
}
.back-top {
  width: 50px;
  height: 50px;
  color: white;
  background: black;
  opacity: 0.3;
  text-align: center;
}
.back-top:hover {
  opacity: 0.6;
}
.seller-app-download {
  text-align: center;
  .download-text {
    word-break: break-word;
    font-size: 14px;
  }
  .download-img {
    margin-top: 10px;
    .google-play-qr {
      width: 160px;
    }
    .google-play-img {
      width: 160px;
      cursor: pointer;
    }
  }
  .el-button {
    width: 100%;
    background: linear-gradient(to right, #ff6405, #ff365f);
    border: none;
    padding: 15px;
  }
}
</style>
